/*
 * fn: encodeBytesToBase64
 *
 * Encodes an input string to base64...
 *
 */
export const encodeBytesToBase64 = (input: string) => {
  const bytes = new TextEncoder().encode(input)
  const binString = Array.from(bytes, (byte) => String.fromCodePoint(byte)).join('')
  return btoa(binString)
}
